import { render, staticRenderFns } from "./PersonDropdown.vue?vue&type=template&id=78666c45&scoped=true&"
import script from "./PersonDropdown.vue?vue&type=script&lang=js&"
export * from "./PersonDropdown.vue?vue&type=script&lang=js&"
import style0 from "./PersonDropdown.vue?vue&type=style&index=0&id=78666c45&scoped=true&lang=scss&"
import style1 from "./PersonDropdown.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78666c45",
  null
  
)

export default component.exports